import { createAction } from '@reduxjs/toolkit';
import { SessaoState } from '../reduxTypes';
import { Empresa } from '../../Entity/Empresa';

export const loginAction = createAction<SessaoState>('SESSAO/SET');
export const logoutAction = createAction('SESSAO_LOGOUT/SET');
export const updateEmpresaAction = createAction<Empresa>('SESSAO/UPDATE_EMPRESA');
export const setSenhaPendenteAction = createAction('SESSAO/SET_SENHA_PENDENTE');
